import React from "react";
import { Link } from "react-router-dom";
import { isNil } from "ramda";

import { DataElement } from "affinityUI/data/dataElement";
import { List } from "affinityUI/data/list";
import { Card } from "affinityUI/elements/card";
import { Restricted } from "lib/auth";

export const Roles: React.FC<{ roles: { id: string; name: string; description?: Maybe<string> }[] }> = ({ roles }) => {
  return (
    <Card>
      <h2>Roles</h2>
      <ul>
        <li>The Affinity dashboard comes with five predefined roles.</li>
        <li>Click edit to configure roles of click confirm to finish set up.</li>
        <li>Once roles have been configured users can be added.</li>
      </ul>
      <List>
        {!isNil(roles) &&
          roles.map((role) => (
            <List.Item
              key={role.id}
              actions={
                <Restricted permits={["change_role"]}>
                  <Link to={`${role.id}/edit`}>Edit</Link>
                </Restricted>
              }
            >
              <DataElement label={role.name}>{role.description}</DataElement>
            </List.Item>
          ))}
      </List>
    </Card>
  );
};
